import { ApprovalRequestStatusCsvSection } from "./ApprovalRequestStatusCsvSection.js";
import { MoveToSetCsvSection } from "./MoveToSetCsvSection.js";
import { TestimonialStatusCsvSection } from "./TestimonialStatusCsvSection.js";
import styles from "../PipelineBrowser.module.css";

export function BatchUpdatesTab() {
  return (
    <>
      <div className={styles.infoBanner}>
        Bulk operations driven from a CSV file. Each tool runs in batches from this browser tab,
        asks for confirmation before it writes and reports what it would change or has changed.
      </div>
      <TestimonialStatusCsvSection />
      <ApprovalRequestStatusCsvSection />
      <MoveToSetCsvSection />
    </>
  );
}
